import { render } from "./permanentlyVisible.vue?vue&type=template&id=3b60b47c"
import script from "./permanentlyVisible.vue?vue&type=script&lang=js"
export * from "./permanentlyVisible.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__